import * as React from "react";
import { useState, useEffect, useRef } from "react";
import axios from 'axios';

interface NotificationHistory {
  notifications: {
    id: string;
    title: string;
    converted_notified_at: string;
  }[],
  history_total_count: number;
}

const PER = 10;
const PLAN_KBN_ONLINE_VIDEO = 30;

const onClickCallLink = (schedule_id) => {
  axios.get<string>(
    '/api/internal/rooms/video_call_url?schedule_id=' + String(schedule_id),
  ).then(function (response) {
    const callUrl = response.data
    if (callUrl != null) {
      window.location.href = callUrl;
    }
  }).catch(function (error) {
  });
}

const NotificationLink = (props) => {
  if (props.notification.notice_kbn == "payment_complete") {
    return <a className="under" href="/credit/history">{props.notification.title}</a>;
  } else if (props.notification.notice_kbn == "schedule_remind" || props.notification.notice_kbn == "schedule_remind_to_patient" ) {
    if (props.notification.plan_kbn == PLAN_KBN_ONLINE_VIDEO) {
      return (
        <a className="under pointer" onClick={() => onClickCallLink(props.notification.d_schedule_id)}>
          {props.notification.title}
        </a>
      );
    } else {
      return (
        <a className="under" data-remote="true" href={`/calendar/schedule_show?from=reserves&schedule_id=${String(props.notification.d_schedule_id)}`}>
          {props.notification.title}
        </a>
      );
    }
  } else if(props.notification.notice_kbn == "transcription_completed" || props.notification.notice_kbn == "retry_summary_completed"){
      return (
        <a className="under" data-remote="true" href={`/calendar/schedule_show?from=reserves&schedule_id=${String(props.notification.d_schedule_id)}&auto_open_transcription=true`}>
          {props.notification.title}
        </a>
      );
  } else {
    return <>{props.notification.title}</>
  }
}

const History = () => {
  const [NotificationHistories, setNotificationHistories] = useState([]);
  const [marker, setMarker] = useState(PER);
  const [limit, setLimit] = useState(PER);
  const [patientword, setPatientword] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);
  const [isFetchedHistories, setIsFetchedHistories] = useState(false);
  const [hitoryTotalCount, setHistoryTotalCount] = useState(0);
  const notifiedAtFromRef = useRef(null);
  const notifiedAtToRef = useRef(null);

  useEffect(() => {
    // メニューバーの未読数バッジを非表示にする
    // _menu.html.erbを読み込んだ後に通知を既読にupdateしているためバッジが表示されてしまうのを防ぐ
    const elem = document.getElementsByClassName('unread-cnt-icon-wrap');
    if(elem.length > 0) {
      elem[0].classList.add('hidden');
      elem[1].classList.add('hidden');
    }

    async function fetchNotificationHistories() {
      const NotificationHistories = await axios.get<NotificationHistory>(
        '/api/internal/notifications/history?limit=' + PER,
      );
      setNotificationHistories(NotificationHistories.data.notifications);
      setHistoryTotalCount(NotificationHistories.data.history_total_count);
      setIsFetchedHistories(true);
    }
    fetchNotificationHistories();
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsDisabled(true);
    const notifiedAtFrom = notifiedAtFromRef.current ? notifiedAtFromRef.current.value : ''
    const notifiedAtTo = notifiedAtToRef.current ? notifiedAtToRef.current.value : ''

    axios.get<NotificationHistory>(
      '/api/internal/notifications/history?search_patient_word=' + patientword
                                   + '&search_notified_at_from=' + notifiedAtFrom
                                   + '&search_notified_at_to=' + notifiedAtTo
                                   + '&limit=' + PER,
    ).then(function (response) {
      setNotificationHistories(response.data.notifications);
      setHistoryTotalCount(response.data.history_total_count);
      setMarker(PER);
    }).catch(function (error) {
    }).finally(() => {
      setIsDisabled(false);
    });
  }

  const loadList = () => {
    const notifiedAtFrom = notifiedAtFromRef.current ? notifiedAtFromRef.current.value : ''
    const notifiedAtTo = notifiedAtToRef.current ? notifiedAtToRef.current.value : ''
    // stateに即座に反映されないので一旦変数に入れてそっちを使う
    const newLimit = limit + PER
    setLimit(newLimit)

    axios.get<NotificationHistory>(
      '/api/internal/notifications/history?search_patient_word=' + patientword
                                   + '&search_notified_at_from=' + notifiedAtFrom
                                   + '&search_notified_at_to=' + notifiedAtTo
                                   + '&limit=' + newLimit,
    ).then(function (response) {
      setNotificationHistories(response.data.notifications);
      setHistoryTotalCount(response.data.history_total_count);
    }).catch(function (error) {
    }).finally(() => {
      setMarker(marker + PER);
    });
  }

  return(
    <>
      <h3>通知履歴</h3>
      <br/>
      <div className="panel panel-success">
        <div className="panel-heading">検索エリア</div>
        <div className="panel-body">
          <form onSubmit={e => handleSubmit(e)} acceptCharset="UTF-8">
            <input name="utf8" type="hidden" value="✓" />
            <div className="form-group" style={{ display: 'inline-block'}}>
              <label htmlFor="search_patient_word">検索したい内容を入力してください(氏名・カナ氏名・携帯電話番号・患者番号・生年月日)</label>
              <input
                type="text"
                name="search_patient_word"
                id="search_patient_word"
                defaultValue=""
                className="form-control col-lg-1"
                placeholder="検索したい内容を入力してください"
                onChange={e => setPatientword(e.currentTarget.value)}
               />
            </div>
            <div className="row">
              <div className="form-group col-sm-10 col-xs-12">
                <label>通知年月日</label>
                <div className="form-inline">
                  <div className="pos_relative pull-left">
                    <input
                      type="text"
                      name="search_notified_at_from"
                      className="form-control datepicker search_reserve_date m5"
                      placeholder="検索日時(from)"
                      ref={notifiedAtFromRef}
                    />
                  </div>
                  <div className="pos_relative pull-left m5">〜</div>
                  <div className="pos_relative pull-left">
                    <input
                      type="text"
                      name="search_notified_at_to"
                      className="form-control datepicker m5"
                      placeholder="検索日時(to)"
                      ref={notifiedAtToRef}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group col-sm-2 col-xs-12 text-right">
                <input
                  type="submit"
                  name="button_search"
                  value="検索"
                  className="btn btn-lg btn-primary mt30"
                  id="button_search"
                  disabled={isDisabled}
                />
              </div>
            </div>
          </form>
        </div>
      </div>

      {NotificationHistories.length == 0 ? (
        isFetchedHistories && <p className="text-center">通知履歴が存在しません</p>
      ) : (
        <div className="table-responsive message-table-content">
          <table id="notice_table" className="table table-bordered table-hover">
            <thead>
              <tr className="success">
                <th scope="col" className="text-center col-sm-1">通知日時</th>
                <th scope="col" className="text-center col-sm-3">通知内容</th>
              </tr>
            </thead>
            <tbody>
              {NotificationHistories.map((NotificationHistory, i) => (
                <tr key={i}>
                  <td className="va_middle text-center">{NotificationHistory.converted_notified_at}</td>
                  <td className="va_middle">
                    <NotificationLink notification={NotificationHistory} />
                    {/* sent_sms_flgが1の時はチケット不足などでSMSの自動送信ができていない */}
                    {NotificationHistory.sent_sms_flg === 1 ?
                      <b style={{color: "red"}}>　（チケット不足の為、SMSを自動送信できませんでした。）</b>
                    : ""
                    }
                    {NotificationHistory.sent_line_flg === 1 ?
                      <b style={{color: "red"}}>　（LINEの自動送信に失敗しました。）</b>
                    : ""
                    }
                    {NotificationHistory.sent_reserve_notification_flg === 1 ?
                      <b style={{color: "red"}}>　（GooCoプッシュ通知のリクエスト処理に失敗しました。）</b>
                    : ""
                    }
                  </td>
                </tr>
              )).slice(0, marker)}
            </tbody>
          </table>
          {
            hitoryTotalCount > marker
              ? <div className="text-center"><button className="btn btn-default more-btn" onClick={loadList}>もっと表示 ▼</button></div>
              : ''
          }
        </div>
      )}
    </>
  );
}

export default History
